export const environment = {
  production: true,
 serverURL : 'https://cri-medesan.wedare.it/json/'
};
